import { t } from '../i18n';
import { uploadIcon } from './icons';

interface FileUploadOverlayProps {
  isDragging: boolean;
}

export function FileUploadOverlay({ isDragging }: FileUploadOverlayProps) {
  if (!isDragging) return null;

  return (
    <div className="file-drop-overlay">
      <div className="file-drop-content">
        <span dangerouslySetInnerHTML={{ __html: uploadIcon }} />
        <p>{t('dragDropHint')}</p>
      </div>
    </div>
  );
}
